import RolesResource from 'remote/resources/roles';

const deleteRole = (roleId: string) => RolesResource.deleteRole(roleId);

export default {
  deleteRole,
};
